import _isEmpty from 'lodash/isEmpty'
import _orderBy from 'lodash/orderBy'

import { WEBSITE_STACK_STATUS_LIVE } from '@/types/business.constants'

export function sortBusinesses(businesses: Business[]): Business[] {
  return _orderBy(
    businesses,
    [b => (b.website?.stackStatus === WEBSITE_STACK_STATUS_LIVE ? 0 : 1), 'name', 'id'],
    ['asc', 'asc', 'asc']
  )
}

export function getLiveBusinesses(businesses: Business[]): Business[] {
  return businesses.filter(
    business => business.website?.stackStatus === WEBSITE_STACK_STATUS_LIVE
  )
}

export function areAllDuplicates(businesses: Business[]): boolean {
  if (_isEmpty(businesses) || businesses.length < 2) {
    return false
  }
  const firstName = businesses[0]?.name
  return businesses.every(business => business.name === firstName)
}
